// @ts-nocheck
import React, { Suspense } from 'react';
import { Canvas, useLoader } from '@react-three/fiber';
import { Bounds, Center, Html, OrbitControls } from '@react-three/drei';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';

interface STLViewerProps {
  urls: string | string[];
}

const Model: React.FC<{ url: string }> = ({ url }) => {
  const geometry = useLoader(STLLoader, url);
  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial color="#c7d5d5" roughness={0.38} metalness={0.32} />
    </mesh>
  );
};

const STLViewer: React.FC<STLViewerProps> = ({ urls }) => {
  const models = Array.isArray(urls) ? urls : [urls];

  return (
    <div className="model-viewer" aria-label="Interactive 3D model viewer">
      <Canvas camera={{ position: [4, 3, 5], fov: 45 }} dpr={[1, 2]}>
        <ambientLight intensity={1.4} />
        <directionalLight position={[4, 6, 7]} intensity={2.2} />
        <directionalLight position={[-6, 2, -3]} intensity={1.1} color="#67b2e8" />
        <Suspense fallback={<Html center><span className="model-viewer__loading">Loading model...</span></Html>}>
          <Bounds fit clip observe margin={1.3}>
            <Center>
              <group>{models.map(url => <Model key={url} url={url} />)}</group>
            </Center>
          </Bounds>
        </Suspense>
        <OrbitControls makeDefault enableDamping />
      </Canvas>
      <span className="model-viewer__hint">Drag to rotate. Scroll to zoom.</span>
    </div>
  );
};

export default STLViewer;